import IntegrationsCloud from '@/components/IntegrationsCloud';
import { ModuleIntegrationsCloudFragment } from '@/graphql';
import { getSingleLink } from '@/lib/craft-utils';
import { parseHtml } from '@/lib/parse-html';
import { FC } from 'react';

interface IntegrationsCloudModuleProps {
  props: CraftModuleFragment<ModuleIntegrationsCloudFragment>;
}

const IntegrationsCloudModule: FC<IntegrationsCloudModuleProps> = ({ props }) => {
  if (Array.isArray(props)) {
    props = props[0];
  }

  if (!props) return null;

  const cta = getSingleLink(props.cta);

  return (
    <IntegrationsCloud
      heading={props.heading ?? ''}
      text={parseHtml(props.text)}
      cta={
        cta
          ? {
            text: cta.text,
            url: cta.url,
          }
          : undefined
      }
    />
  );
};

export default IntegrationsCloudModule;
